import { Claim } from '../types';
import { hasCommunityAccess } from './claims';

type Payload = {
	isLimitedAccess: boolean;
	claimsIds: Array<number>;
	items: Array<{ link: string; id: number }>;
};

export const getInitialPath = ({
	isLimitedAccess,
	items,
	claimsIds,
}: Payload) => {
	if (isLimitedAccess || !hasCommunityAccess(claimsIds)) {
		const hasDealExplorer = claimsIds.includes(Claim['Deal Explorer']);

		if (hasDealExplorer) {
			return '/deal-explorer';
		}

		return items.find(elem => elem.id === Array.from(claimsIds).sort()[0])!
			.link;
	}
	return '/quick-start';
};
